import React, { useEffect, useMemo } from "react";

const Palette = ({
  paletteString,
  setFieldValue,
  disableInputs,
  setPalette,
}) => {
  const parsedColors = useMemo(() => {
    if (!paletteString || paletteString.trim() === "") return [];

    try {
      return JSON.parse(
        paletteString.replace(/None/g, "null").replace(/'/g, '"')
      );
    } catch (err) {
      console.error("Invalid palette JSON:", err);
      return [];
    }
  }, [paletteString]);

  useEffect(() => {
    setPalette(parsedColors);
  }, [parsedColors, setPalette]);

  const handleColorClick = (index) => {
    if (parsedColors.length === 0) return;

    let updatedColors = [...parsedColors];

    if (!updatedColors[index].hasOwnProperty("status")) {
      updatedColors[index].status = null;
    }

    const primaryIndex = updatedColors.findIndex((c) => c.status === "primary");
    const secondaryIndex = updatedColors.findIndex(
      (c) => c.status === "secondary"
    );
    const currentStatus = updatedColors[index].status;

    if (currentStatus) {
      updatedColors[index].status = null;
      if (index === primaryIndex && secondaryIndex !== -1) {
        updatedColors[secondaryIndex].status = "primary";
      }
    } else {
      if (primaryIndex === -1) {
        updatedColors[index].status = "primary";
      } else if (secondaryIndex === -1) {
        updatedColors[index].status = "secondary";
      }
    }

    setFieldValue("website_palette", JSON.stringify(updatedColors));
    setPalette(updatedColors);
  };

  if (parsedColors.length === 0) return null;

  return (
    <div className="my-3 d-flex justify-content-center align-items-center">
      <div
        className="palette-wrapper me-3"
        onClick={(e) => e.stopPropagation()}
      >
        {parsedColors.map((color, index) => {
          const primaryIndex = parsedColors.findIndex(
            (c) => c.status === "primary"
          );
          const secondaryIndex = parsedColors.findIndex(
            (c) => c.status === "secondary"
          );
          const isDisabled =
            primaryIndex !== -1 && secondaryIndex !== -1 && !color.status;

          return (
            <div key={index} className="color-container text-center mx-1">
              <div
                className={`color-box ${color.status || ""} ${
                  isDisabled ? "disabled" : ""
                }`}
                style={{
                  backgroundColor: color.hex,
                  border: color.status
                    ? "3px solid #b3b3b3"
                    : "1px solid #b3b3b3",
                  opacity: isDisabled ? 0.4 : 1,
                  pointerEvents: isDisabled || disableInputs ? "none" : "auto",
                  width: "40px",
                  height: "40px",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (!disableInputs) handleColorClick(index);
                }}
              ></div>
              {color.status === "primary" && (
                <i
                  className="fa-solid fa-p"
                  style={{ fontSize: "0.75rem", color: "#FF5837" }}
                ></i>
              )}
              {color.status === "secondary" && (
                <i
                  className="fa-solid fa-s"
                  style={{ fontSize: "0.75rem", color: "#000" }}
                ></i>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Palette;
